import profileViewTpl from './views/profileView.html';
import './profileSetting.scss';
import profileViewCtrl from './controllers/profileViewController';


var profilView = "profileViewPage"
var module = angular.module('app.profileView', [
        //import modules
    ])
    .component(profilView, {
        templateUrl: profileViewTpl,
        controllerAs: "profileViewCtrls",
        controller: profileViewCtrl
    })
    .controller('profileViewCtrl', profileViewCtrl);

module.constant("profileCons", {
    API_GET_PROFILE_SETTING_ROLES: "/v0/profile/settings/role/list/",
    API_GET_PROFILE_USERS: "/v0/profile/user/role/list/",
    API_USER_PERSONAL: "/v0/profile/user/personal/",
    API_USER_MODULES_FEATURE: "/v0/profile/modules_feature_role/",
    API_TEACHER_ENDORSE_DETAILS: "/v0/profile/details/list/",
    API_HOD_ENDORSE_DETAILS: "/v0/profile/departments/list/",
    API_HOS_ENDORSE_DETAILS: "/v0/profile/sections/list/",
    API_PARENT_CHILD_DETAILS: "/v0/profile/child/list/",
    API_GET_SESSION: "/v0/profile/dropdown/session/detail/",
    API_GET_CURRICULUM: "/v0/profile/dropdown/curriculum/detail/",
    API_GET_ALL_CLASS: "/v0/profile/dropdown/allclass/detail/",
    API_GET_CLASS: "/v0/profile/dropdown/class/detail/",
    API_GET_BATCH: "/v0/profile/dropdown/batch/detail/",
    API_GET_SUBJECTS: "/v0/profile/dropdown/department/detail/",
    API_GET_STUDENTS: "/v0/profile/dropdown/student/detail/",
    API_UPDATE_DEPARTMENT: "/v0/profile/hod/details/save",
    API_DELETE_DEPARTMENT: "/v0/profile/hod/details/delete",
    API_UPDATE_SECTION: "/v0/profile/hos/details/save",
    API_DELETE_SECTION: "/v0/profile/hos/details/delete",
    API_UPDATE_CHILD: "/v0/profile/parent/details/save",
    API_DELETE_CHILD: "/v0/profile/parent/details/delete",
    API_UPDATE_WORKING_HRS: "/v0/profile/update-working-det"
});

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('profileSetting', {
            url: '/profile-setting',
            views: {
                '@': {
                    template: profileSettingTpl,
                    controller: profileSettingCtrl,
                    controllerAs: 'userProfileCtrl'
                }
            }
        })
        .state('profileData', {
            url: '/profile-view/:person_id',
            views: {
                '@': {
                    template: profileViewTpl,
                    controller: profileViewCtrl,
                    controllerAs: 'profileViewCtrls'
                }
            }
        })

}); */


// WEBPACK FOOTER //
// ./src/app/profileSetting/profileViewModule.js